<template>
  <div class="home-setting">
    <el-row :gutter="12">
      <el-col :span="12">
        <card class="w-100">
            <el-row>
            <el-col :span="24" class="text-right">
              <h5 class="float-left header" style="margin-bottom: 5px">메인 이미지/비디오 관리</h5>
              <el-button type="primary" size="small" icon="el-icon-check" @click="mainImageMng()">관 리</el-button>
            </el-col>
            </el-row>
        </card>
      </el-col>  

      <el-col :span="12">
        <card class="w-100">
            <el-row>
            <el-col :span="24" class="text-right">
              <h5 class="float-left header" style="margin-bottom: 5px">매체소개 관리 </h5>
              <el-button type="primary" size="small" icon="el-icon-check" @click="mainMediaMng()">관 리</el-button>
            </el-col>
            </el-row>
        </card>
      </el-col>  

    </el-row>  
    <el-row :gutter="12">
      <el-col :span="12">
        <card class="w-100 widecolor">
          <el-collapse accordion>
            <el-collapse-item>      

              <template slot="title">
                <h5 slot="header" class="header" style="margin-bottom: 5px">와이드칼라 담당 및 문의</h5>
              </template>        
              <el-row class="mt-2">
              <h6 class="fs18">연락처</h6>
              <el-col :span="24">
                <vue-editor id="editor1" v-model="wideColor.tel" :editorToolbar="customToolbar"></vue-editor>
              </el-col>
              </el-row>
              <el-row class="mt-3">
              <h6 class="fs18">담당자</h6>
              <el-col :span="24">
                <vue-editor id="editor2" v-model="wideColor.info" :editorToolbar="customToolbar"></vue-editor>
              </el-col>
              </el-row>
              <el-col :span="24" style="margin-top: 10px">
                <div class="pull-right">
                  <el-button type="primary" icon="el-icon-plus" v-on:click="setInfo(wideColor)">내용저장</el-button>
                </div>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </card>
      </el-col>

      

<!-- 
      <el-col :span="12">
        <card class="w-100">
          <h5 slot="header" class="header" style="margin-bottom: 5px">매체소개관리 (이미지 넓이 : 1280px)</h5>
          <el-row>
            <el-col :span="24" class="text-center">
              <img v-if="mainInfo.show"
                v-bind:src="'/api/common/path/' + this.mainInfo.filePath + '?name='+ encodeURI(encodeURIComponent(this.mainInfo.fileName))"
                style="width: 380px"/>
            </el-col>
            <el-col :span="24" style="margin-top: 10px">
              <div class="pull-right">
                  <el-upload
                    class="upload-demo"
                    ref="mediaInfo"
                    action="/api/settings/info/upload"
                    :headers="header"
                    :data="getFormParam"
                    :on-remove="handleRemove"
                    :limit="1"
                    :on-success="handleSuccess"
                    :on-change="onChange"
                    :auto-upload="false">
                    <el-button slot="trigger" size="small" type="primary">이미지파일 선택</el-button>
                  </el-upload>
              </div>
            </el-col>
            <el-col :span="24" style="margin-top: 10px">
              <div class="pull-right">
                <el-button type="primary" icon="el-icon-plus" v-on:click="setMediaInfo(mainInfo)">이미지저장</el-button>
              </div>
            </el-col>
          </el-row>
        </card>
      </el-col> -->


    </el-row>
  </div>
</template>

<script>
  import Vue from 'vue'

  import {VueEditor} from "vue2-editor";
  import {Form, FormItem, Button, Row, Col, Checkbox, Upload} from 'element-ui'
  import MainInfoProxy from "../../../../proxies/MainInfoProxy";

  Vue.use(Checkbox)
  Vue.use(Button)
  Vue.use(Row)
  Vue.use(Col)
  Vue.use(Form)
  Vue.use(FormItem)
  Vue.use(Upload)

  export default {
    name: "SettingsHomeInfo",
    components: {
      VueEditor
    },
    created: function () {
      this.$store.dispatch('common/setMenuTitle', "홈페이지 관리");

      
      /*
      new MainInfoProxy()
        .find(this.wideColor.infoType)
        .then((response) => {
          if (response.mainInfo !== undefined) {
            this.wideColor = response.mainInfo;
          }
        })
      */
        this.getMediaInfo();
    },
    computed: {
      getFormParam: function () {
        return this.mainInfo;
      }
    },
    methods: {
      mainImageMng() {

        this.$modal.show(
            () => import ('@/components/Pages/Views/Settings/SettingsMainImage.vue'),
            { },
            { width:'1200px' },
            { }
        )   

      },
      mainMediaMng() {

        this.$modal.show(
            () => import ('@/components/Pages/Views/Settings/SettingsMainMedia.vue'),
            { },
            { width:'1200px' },
            { }
        )   

      },

      getMediaInfo() {
        new MainInfoProxy()
        .getMainContactInfo()
        .then(response => {
          this.wideColor = response.item
        })
        /*
        new MainInfoProxy()
          .find(this.mainInfo.infoType)
          .then((response) => {
            if (response.mainInfo !== undefined) {
              this.mainInfo = response.mainInfo;
            }
          })
          */
      },
      setMediaInfo(mainInfo) {
        if (confirm("저장하시겠습니까?")) {
          if(this.$refs["mediaInfo"].uploadFiles.length > 0){
            this.mainInfo.show = true;
            this.$refs["mediaInfo"].submit();
          }
        }
      },
      setInfo(mainInfo) {
        if (confirm("저장하시겠습니까?")) {
          new MainInfoProxy()
          .saveMainContactInfo(this.wideColor)
          .then((response) => {
              if (response.header.returnCode === "OK") {
                alert("저장되었습니다.");
              } else {
                alert(response.header.resultMessages);
              }
          });
          /*
            .create(mainInfo)
            .then((response) => {
              if (response.header.returnCode === "OK") {
                alert("저장되었습니다.");
              } else {
                alert(response.header.resultMessages);
              }
            });
          */
        }
      },
      handleRemove(file, fileList) {
        this.$refs["mediaInfo"].clearFiles();
      },
      handleSuccess(response, files, fileList) {
        if (response.header.returnCode === "OK") {
          this.$refs["mediaInfo"].clearFiles();
          this.getMediaInfo();
          alert("저장되었습니다.");
        } else {
          alert(response.header.resultMessages);
        }
      },
      onChange(file, fileList) {
        this.fileChange = true;
      }
    },
    data() {
      return {
        boardImg: undefined,
        fileChange : false,
        wideColor: {
          infoType: "wideColor",
          show: false,
          infoHtml: "",
        },
        mainInfo: {
          infoType: "mediaInfo",
          infoHtml: "",
          show: false
        },
        header: {
          Authorization:$cookies.get('id_token')
        },
        customToolbar: [[{'header': [1, 2, 3, 4, 5, 6, false]}], ["bold", "italic", "underline", 'strike'], [{list: "ordered"}, {list: "bullet"}], ["image"], ['clean']]
      }
    }
  }
</script>

<style>
</style>
<style scoped>
.widecolor ::v-deep .el-collapse {
  border: none;
}
.widecolor ::v-deep .el-collapse-item__header { border-bottom: none; height: auto;}
.widecolor ::v-deep .el-collapse-item__wrap { border-bottom: none;;}
.widecolor ::v-deep .el-icon-arrow-right {font-size: 24px; font-weight: 900;}

::v-deep .ql-editor {
    min-height: 100px;
    height: 100px;
}

.home-setting .header { font-size: 22px; }

</style>
